export const colors = {
  // todo: update gray to be `light_material`?
  legacyForaBlue: '#00A5CC',
  // it's recommended to not use the raw colors below, but instead the mapped tokens (like surface.container)
  // new theme raw colors:
  light_material: {
    0: '#feffff',
    25: '#f5f9fc',
    50: '#eff4f8',
    75: '#e7eef3',
    100: '#dfe7ef',
    150: '#c0ccd9',
    200: '#dfe7ef',
    500: '#69778d',
    600: '#525e74',
    900: '#1d2330',
    1000: '#12161d'
  },
  neutral: {
    0: '#FEFFFF',
    25: '#F0F2F5',
    50: '#E8EBF0',
    100: '#E1E5EA',
    250: '#5161794D',
    300: '#C4CDDA',
    400: '#A6B3C4',
    450: '#677B98CC',
    500: '#677B98',
    550: '#5C6E89',
    600: '#576881',
    700: '#516179',
    850: '#3D485C'
  },
  scrim: {
    0: '#feffff',
    100: '#12161d1A',
    300: '#12161d4D',
    500: '#12161d80',
    700: '#12161dB3',
    900: '#12161dE6'
  },
  /****************************************************
   * BRAND
   ****************************************************/
  brand_blue: {
    0: '#FEFFFF',
    25: '#E7EEFD',
    50: '#DCE5FC',
    100: '#D0DDFB',
    250: '#0F3CA84D',
    300: '#aac1f5',
    400: '#789df1',
    450: '#1353ECCC',
    500: '#1353EC',
    550: '#124DDB',
    600: '#1148CA',
    700: '#0f3ca8',
    850: '#113281'
  },
  brand_light_blue: {
    0: '#feffff',
    25: '#E7F5FF',
    50: '#DBF0FF',
    100: '#CFEBFF',
    250: '#1176c34D',
    300: '#a8d7fa',
    400: '#75c3fc',
    450: '#0d99ffCC',
    500: '#0d99ff',
    550: '#0F88E1',
    600: '#107FD2',
    700: '#1176c3',
    850: '#155589'
  },
  brand_purple: {
    0: '#feffff',
    25: '#F2EFFF',
    50: '#ECE7FF',
    100: '#E5DFFF',
    250: '#614cc34D',
    300: '#cbc4fa',
    400: '#b2a3fc',
    450: '#7e5effCC',
    500: '#7e5eff',
    550: '#7055E1',
    600: '#6951D2',
    700: '#614cc3',
    850: '#463C89'
  },
  /****************************************************
   * STATUS / STATE COLORS
   ****************************************************/
  green_system: {
    0: '#feffff',
    25: '#E5F6F1',
    50: '#D9F1EA',
    100: '#CCEDE4',
    250: '#077e604D',
    300: '#a3dacf',
    400: '#6ec8b2',
    450: '#00a376CC',
    500: '#00a376',
    550: '#04916B',
    600: '#068866',
    700: '#077e60',
    850: '#0F5A4D'
  },
  red_system: {
    0: '#fffffe',
    25: '#FDEDEE',
    50: '#FDE3E6',
    100: '#FCDADD',
    250: '#b43b484D',
    300: '#efbdc4',
    400: '#f096a0',
    450: '#f04755CC',
    500: '#f04755',
    550: '#D2414F',
    600: '#C33E4C',
    700: '#b43b48',
    850: '#79313e'
  },
  yellow_system: {
    25: '#FFF7E9',
    50: '#FFF3DE',
    100: '#FFF0D3',
    250: '#b43b484D',
    300: '#f4e0b4',
    400: '#f7d184',
    450: '#815013CC',
    500: '#ffb221',
    550: '#C0811A',
    600: '#A16917',
    700: '#815013',
    850: '#593e1d',
    950: '#3a2400'
  },
  /****************************************************
   * TAGS
   ****************************************************/
  gold_tag: {
    0: '#fffffe',
    25: '#b281001A',
    50: '#b2810026',
    100: '#b2810033',
    500: '#b28100'
  },
  sunset_tag: {
    0: '#fffffe',
    25: '#df59001A',
    50: '#df590026',
    100: '#df590033',
    500: '#df5900'
  },
  teal_tag: {
    0: '#feffff',
    25: '#009ead1A',
    50: '#009ead26',
    100: '#009ead33',
    500: '#009ead'
  },
  magenta_tag: {
    0: '#ffffff',
    25: '#bd52bd1A',
    50: '#bd52bd26',
    100: '#bd52bd33',
    500: '#bd52bd'
  },
  fuchsia_tag: {
    0: '#ffffff',
    25: '#d53e651A',
    50: '#d53e6526',
    100: '#d53e6533',
    500: '#d53e65'
  },
  emerald_tag: {
    0: '#ffffff',
    25: '#f3f6f4',
    50: '#e7ede8',
    100: '#cfded2',
    500: '#00a24b'
  },
  amethyst_tag: {
    0: '#ffffff',
    25: '#f5f4f9',
    50: '#ebeaf2',
    100: '#d9d7e7',
    500: '#8a70e5'
  },
  blue_tag: {
    0: '#ffffff',
    25: '#f3f5f8',
    50: '#e5eaf0',
    100: '#cfd8e6',
    500: '#367fe7'
  }
};
